import { Model } from '../model';

export enum PoviderType {
    None = 0,
    Whatsapp = 1
}
